import { Navigate } from 'react-router-dom';

const STORAGE_KEY = 'faye_funnel_data';

/**
 * Route guard that checks sessionStorage for required funnel data.
 * Redirects to /intro if any required field is missing or empty.
 *
 * @param {Object} props
 * @param {string[]} props.requiredFields - Field names to check in session data
 * @param {React.ReactNode} props.children - The page to render if checks pass
 */
const ProtectedRoute = ({ requiredFields = [], children }) => {
    // If no fields required, render immediately
    if (requiredFields.length === 0) return children;

    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return <Navigate to="/intro" replace />;

        const data = JSON.parse(raw);

        for (const field of requiredFields) {
            const value = data[field];

            if (value === undefined || value === null || value === '') {
                return <Navigate to="/intro" replace />;
            }

            // Arrays must be non-empty
            if (Array.isArray(value) && value.length === 0) {
                return <Navigate to="/intro" replace />;
            }
        }
    } catch {
        return <Navigate to="/intro" replace />;
    }

    return children;
};

export default ProtectedRoute;
